import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "details-modal" }
const _hoisted_2 = { class: "details-modal-bar" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "details-modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.modelValue)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "details-modal-overlay",
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.showBack)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btnprimary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back')))
                }, "Back"))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "details-modal-heading",
              title: _ctx.title
            }, _toDisplayString(_ctx.title), 9, _hoisted_3),
            _createElementVNode("button", {
              class: "float-right text-3xl",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
            }, _cache[3] || (_cache[3] = [
              _createElementVNode("img", {
                src: _imports_0,
                class: "h-5 w-5 cursor-pointer"
              }, null, -1)
            ]))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}